import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing['2xm']};
  width: 100%;
  color: ${theme.colors.neutral[90]};
  font-size: ${theme.typography.sizes['xs']};
  line-height: ${theme.typography.lineHeight.md};
`

export const OverviewValues = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${theme.spacing.md};
  margin: ${theme.spacing['2xm']} 0;
`

export const CurrencyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`
